import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/contact/page.tsx");
